import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 4500,
  timerProgressBar: true,
  didOpen: toast => {
    toast.addEventListener("mouseenter", Swal.stopTimer);
    toast.addEventListener("mouseleave", Swal.resumeTimer);
  }
});

export default class ErrorService {
  constructor() {
    // this.initHandler();
  }

  static onError(error) {
    console.log(error.message);
  }

  static initHandler() {
    const scope = this;
    window.onerror = (message, url, lineNo, columnNo, error) => {
      console.log(error, "test");
      if (error) {
        scope.onError(error);
        console.log(message, url, lineNo, columnNo, error);
      }
    };
  }

  static displayErrorAlert(error) {
    const message =
      (error && error.message) ||
      (typeof error === "string" ? error : "An error occurred");

    Toast.fire({
      icon: "error",
      title: message
    });
  }

  static displaySuccessAlert(message, title = "Success") {
    Toast.fire({
      icon: "success",
      title: title,
      text: message
    });
  }
}
